import { render } from "./MainContact.vue?vue&type=template&id=25006cd5&scoped=true"
import script from "./MainContact.vue?vue&type=script&lang=js"
export * from "./MainContact.vue?vue&type=script&lang=js"

import "./MainContact.vue?vue&type=style&index=0&id=25006cd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25006cd5"]])

export default __exports__